
export function purchaseAmountString(co2eKg: number) {
  if (co2eKg < 3000) {
    return `${co2eKg} kg`
  } else {
    const decimals = co2eKg % 1000 === 0 ? 0 : 1
    return `${(co2eKg / 1000).toFixed(decimals)} tonnes`
  }
}

export default function PurchaseAmount({ co2eKg }: { co2eKg: number }) {
  return <>{purchaseAmountString(co2eKg)}</>
}

